// export const baseUrl = "http://35.208.65.24:3007";
export const baseUrl = "/api";
// export const baseUrl = "http://localhost:3007";

export function buildQuery(query) {
  let queries = Object.keys(query).map((k) => `${k}=${query[k]}`);
  return `?${queries.join("&")}`;
}
